import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import copyToClipboard from 'copy-to-clipboard';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { getIcon } from './helpers';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonCopyValue = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var size = _ref.size,
    valueToCopy = _ref.valueToCopy,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex,
    onKeyDown = _ref.onKeyDown,
    onClick = _ref.onClick,
    onValueRequest = _ref.onValueRequest,
    disabled = _ref.disabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var timerId = useRef();
  var closeTooltip = function closeTooltip() {
    return setIsChecked(false);
  };
  var handleCopy = function handleCopy(event, asyncValue) {
    var value = asyncValue || valueToCopy;
    value && copyToClipboard(value, {
      format: 'text/plain'
    });
    setIsChecked(true);
    clearTimeout(timerId.current);
    timerId.current = setTimeout(closeTooltip, 2000);
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
  };
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    if (onValueRequest) {
      onValueRequest().then(function (_ref2) {
        var success = _ref2.success,
          value = _ref2.value;
        if (success) {
          handleCopy(event, value);
        }
      });
    } else {
      handleCopy(event);
    }
  };
  useEffect(function () {
    return function () {
      closeTooltip();
      clearTimeout(timerId.current);
    };
  }, []);
  return /*#__PURE__*/_jsx("button", {
    className: styles.buttonCopyValue,
    "data-size": size,
    "data-disabled": disabled || undefined,
    onClick: handleClick,
    "data-test-id": "button-copy-value",
    ref: ref,
    onKeyDown: onKeyDown,
    tabIndex: tabIndex,
    type: "button",
    disabled: disabled,
    children: getIcon({
      size: size,
      isChecked: isChecked
    })
  });
});